import React from "react";

const ViewFormInput = ({ index, title, answer, setAnswer, type }) => {
  return (
    <div className="form-group">
      <label>{title}</label>
      <input
        type={type}
        className="form-control"
        value={answer}
        onChange={(event) => setAnswer(index, event.target.value)}
      ></input>
    </div>
  );
};

export default ViewFormInput;
